import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderDashboard from '../Components/HeaderDashboard';
import { GetApprovalDetails } from '../Services/ApprovalAPI';
import BusTripQueueDetail from '../../src/Dashboard/BusTripQueueDetail'
import FlightTripQueueDetail from '../../src/Dashboard/FlightTripQueueDetail'
import HotelTripQueueDetail from '../../src/Dashboard/HotelTripQueueDetail'
import InsuranceTripQueueDetail from '../../src/Dashboard/InsuranceTripQueueDetail'

const TripQueueDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const referenceNo = queryParams.get("referenceNo");
    const productType = queryParams.get("productType");

    const [approvalDetails, setApprovalDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const hasCalled = useRef(false);

    useEffect(() => {
        if (referenceNo && productType) {
            if (hasCalled.current) return;
            hasCalled.current = true;
            fetchApprovalDetails(referenceNo, productType);
        } else {
            console.warn("Missing referenceNo and productType");
        }
    }, [referenceNo, productType]);

    const fetchApprovalDetails = async (referenceNo, productType) => {
        try {
            setLoading(true);
            setError("");
            const response = await GetApprovalDetails(referenceNo, productType);
            setApprovalDetails(response.approvalDetails);
            console.log("setApprovalDetails", response.approvalDetails)


        } catch (err) {
            setError("Failed to load flight Requested Approval details. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const [timeLeft, setTimeLeft] = useState("");
    const getRemainingTime = (blockedOn) => {
        try {
            if (!blockedOn) return "Error";
            const blockTime = new Date(blockedOn);
            if (isNaN(blockTime)) return "Invalid Date";

            const expiryTime = new Date(blockTime.getTime() + 15 * 60000);
            const diff = expiryTime - new Date();
            if (diff <= 0) return "Expired";
            const m = Math.floor(diff / 60000);
            const s = Math.floor((diff % 60000) / 1000);
            return `${m}m ${s}s left`;
        } catch (error) {
            return "Error";
        }
    };

    const blockedOn = approvalDetails?.bookingStartTime;
    useEffect(() => {
        if (!blockedOn) {
            setTimeLeft("No Time");
            return;
        }
        setTimeLeft(getRemainingTime(blockedOn));
        const interval = setInterval(() => {
            setTimeLeft(getRemainingTime(blockedOn));
        }, 1000);
        return () => clearInterval(interval);
    }, [blockedOn]);

    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Dashboard</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/TripQueue" className="text-muted text-hover-primary">Trip Queue</a>
                                </li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>
                                <li class="breadcrumb-item text-gray-900">Trip Queue Details</li>

                            </ul>
                        </div>
                    </div>
                   <div class="d-flex align-items-center flex-wrap">
            <div class="flex-shrink-0 me-2 d-none-mob">
              <ul class="nav" role="tablist">
                <li class="nav-item" role="presentation">
                  <a href="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} >
                    <img src="/assets/images/back.png" width={30} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
                </div>
            </div>

            {
                (() => {
                      if (approvalDetails?.productType === "Flight" && Array.isArray(approvalDetails?.airBookingResponse) && approvalDetails.airBookingResponse.length > 0) {
                         return (
                            <FlightTripQueueDetail approvalDetails={approvalDetails} />
                        );
                    }
                    else if (approvalDetails?.productType === "Bus") {
                        return (
                            <BusTripQueueDetail approvalDetails={approvalDetails} />
                        );
                    }
                    else if (approvalDetails?.productType === "Hotel") {
                        return (
                            <HotelTripQueueDetail approvalDetails={approvalDetails} />
                        );
                    }
                     else if (approvalDetails?.productType === "Insurance") {
                        return (
                            <InsuranceTripQueueDetail approvalDetails={approvalDetails} />
                        );
                    }
                    else {
                        return <div>No data</div>;
                    }
                })()
            }
        </>
    )
};

export default TripQueueDetail;